function getYouTubeId(src) {
  try {
    const url = new URL(src);

    if (url.hostname.includes("youtube.com") && url.searchParams.get("v")) {
      return url.searchParams.get("v");
    }

    const embedMatch = url.pathname.match(/\/embed\/([a-zA-Z0-9_-]+)/);
    if (embedMatch) return embedMatch[1];
  } catch {
    const fallback = src.match(/(?:embed\/|v=)([a-zA-Z0-9_-]+)/);
    return fallback ? fallback[1] : null;
  }

  return null;
}

export default function transformVideos(root = document) {
  const iframes = root.querySelectorAll("iframe");

  iframes.forEach((iframe) => {
    const src = iframe.getAttribute("src") || "";

    // Only YouTube
    if (
      !src.includes("youtube.com") &&
      !src.includes("youtube-nocookie.com")
    ) {
      return;
    }

    if (iframe.dataset.szVideoProcessed === "true") return;
    iframe.dataset.szVideoProcessed = "true";

    const videoId = getYouTubeId(src);
    if (!videoId) return;

    const useNoCookie = src.includes("youtube-nocookie.com");

    const wrapper = document.createElement("div");
    wrapper.className = "video";
    wrapper.dataset.videoId = videoId;
    wrapper.dataset.noCookie = useNoCookie ? "true" : "false";

    wrapper.innerHTML = `
      <button class="video__cover">
        <span class="video__play-button">
          <span class="visually-hidden">Play video</span>
        </span>
      </button>
      <iframe
        src=""
        allow="autoplay"
        title=""
        aria-hidden="true"
        tabindex="-1"
      ></iframe>
    `;

    // thumbnail
    wrapper.querySelector(".video__cover").style.backgroundImage =
      `url('https://img.youtube.com/vi/${videoId}/hqdefault.jpg')`;

    iframe.replaceWith(wrapper);
  });
}